import { makeStyles } from '@mui/styles'
import { InformationalTooltipProps } from '../_props/InformationalTooltipProps'

export default (size: InformationalTooltipProps['size'] = 'normal') => {
    const sizesEm = {
        normal: 1.5,
        large: 2.35,
    }

    const useStyles = makeStyles((theme: any) => ({
        InformationalTooltipTooltip: {
            maxWidth: '32rem',
            width: 'auto',
        },
        InformationalTooltipTooltipWithMargin: {
            marginRight: '4rem',
        },
        InformationalTooltipTooltipPopper: {
            left: '0px !important',
        },
        InformationalTooltipIcon: {
            width: `${sizesEm[size]}rem`,
            height: `${sizesEm[size]}rem`,
            fill: theme.palette.primary.main,
        },
        mobileTooltip: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        desktopTooltip: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'block',
            },
        },
    }))

    return useStyles()
}
